import Pin from "./Pin";
import PinBothDirection from "./PinBothDirection";
(function(){
    window.Pin = Pin;
    window.PinBothDirection = PinBothDirection;
})()